import { render, staticRenderFns } from "./AppBackground.vue?vue&type=template&id=7d0650b4&scoped=true"
import script from "./AppBackground.vue?vue&type=script&lang=ts"
export * from "./AppBackground.vue?vue&type=script&lang=ts"
import style0 from "./AppBackground.vue?vue&type=style&index=0&id=7d0650b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0650b4",
  null
  
)

export default component.exports